(function () {
  'use strict';

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }
    callback();
  }

  function initGuide(root) {
    if (!root || root.dataset.zvAppReady === 'true') return;
    root.dataset.zvAppReady = 'true';

    var jump = root.querySelector('[data-zv-app-jump]');
    var navLinks = Array.prototype.slice.call(root.querySelectorAll('[data-zv-app-nav]'));
    var sections = Array.prototype.slice.call(root.querySelectorAll('[data-zv-app-section]'));
    var backTop = root.querySelector('[data-zv-app-back-top]');
    var faqItems = Array.prototype.slice.call(root.querySelectorAll('.zv-app-handleiding__faq details'));
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function findTarget(selector) {
      if (!selector || selector.charAt(0) !== '#') return null;
      try {
        return root.querySelector(selector) || document.querySelector(selector);
      } catch (error) {
        return null;
      }
    }

    function goTo(selector, updateUrl) {
      var target = findTarget(selector);
      if (!target) return;

      target.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'start'
      });

      if (updateUrl !== false && window.history && window.history.replaceState) {
        if (window.location.hash !== selector) window.history.pushState(null, '', selector);
      }
    }

    root.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link || !root.contains(link)) return;

      var selector = link.getAttribute('href');
      if (!findTarget(selector)) return;

      event.preventDefault();
      goTo(selector, true);
    });

    if (jump) {
      jump.addEventListener('change', function () {
        goTo(jump.value, true);
      });
    }

    var navigation = window.ZVGuideNavigation.create({
      root: root, sections: sections, links: navLinks, select: jump
    });
    function restoreHash() {
      if (window.location.hash) goTo(window.location.hash, false);
      navigation.sync();
    }
    window.addEventListener('hashchange', restoreHash);
    window.addEventListener('popstate', restoreHash);

    function updateBackTop() {
      if (!backTop) return;
      backTop.classList.toggle('is-visible', window.scrollY > 760);
    }

    if (backTop) {
      updateBackTop();
      window.addEventListener('scroll', updateBackTop, { passive: true });
      backTop.addEventListener('click', function () {
        root.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    }

    faqItems.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        faqItems.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });

    if (window.location.hash && findTarget(window.location.hash)) {
      window.setTimeout(function () {
        goTo(window.location.hash, false);
      }, 80);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-zv-app-handleiding]').forEach(initGuide);
  }

  onReady(function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
